/**
 * title-fit — ОБЩИЙ модуль автоподбора шрифта ЗАГОЛОВКА экрана для ВСЕХ экранов
 * (board / daily / result / replay / leaderboard / teaser). owner-directive
 * 2026-05-30: «заголовки везде одинакового шрифта и размера; то же fill-правило,
 * что на кнопках (0.7), наследуется деревом; привязка к доске как у игры».
 *
 * Единый источник правила: заголовок = `.screen-title` (внешний вид/размер — в
 * стволе styles/postament.css: потолок `--fs-board-title` = cell·0.5, в rail
 * cell·0.8 — «привязан к доске как у игры»). Здесь — ОДНО поведение autofit:
 *   · stacked: mode:'line' (весь заголовок в одну строку, ужимается по ширине),
 *   · rail: area-fit (заполняет узкую панель),
 *   · обе раскладки: fillRatio SCREEN_TITLE_FILL (0.7 — та же ручка, что кнопки),
 *     потолок = размер из CSS (capToDesign), пол читаемости FS_BUTTON_MIN_PX.
 *
 * Так все заголовки рендерятся на ОДНОМ board-привязанном потолке по ОДНОМУ
 * правилу → одинаковы на любом экране; «Реплей» больше не мельче.
 */

import { attachAutofit, type AutofitHandle } from './autofit-text.js';
import { FS_BUTTON_MIN_PX } from './viewport-sizer.js';

/**
 * Доля заполнения области заголовком (0…1) — та же ручка «насколько крупно текст
 * заполняет область», что ACTION_RAIL_FILL у кнопок (owner-directive 2026-05-30).
 */
export const SCREEN_TITLE_FILL = 1;

/**
 * Привязать общий autofit заголовка к экрану. `root` — корень экрана (наблюдается
 * ResizeObserver'ом autofit). Возвращает handle с detach() для unmount.
 */
export function attachTitleFit(root: HTMLElement): AutofitHandle {
  return attachAutofit(root, [
    {
      selector: '.screen-title',
      mode: 'line',
      fillRatio: SCREEN_TITLE_FILL,
      capToDesign: true,
      minPx: FS_BUTTON_MIN_PX,
      onlyLayout: 'stacked',
      // НЕ-обрезающий последний рубеж (skill §0.A P1, owner «никогда не обрезать»): на
      // экстремально низком/узком вьюпорте (724×246 owner-phone) длинный i18n-заголовок
      // (de «Spiel beendet» / fr «Partie terminée») не влезает даже на floor-шрифте →
      // вместо silent hard-crop (postament.css overflow:hidden backstop) хвост МЯГКО
      // угасает (mask-fade на .screen-title.is-clamped). Ставится УСЛОВНО (только при
      // floor+overflow) → короткие/влезающие заголовки целые, без угасания.
      clampClass: 'is-clamped',
    },
    {
      selector: '.screen-title',
      fillRatio: SCREEN_TITLE_FILL,
      capToDesign: true,
      minPx: FS_BUTTON_MIN_PX,
      onlyLayout: 'rail',
      clampClass: 'is-clamped',
    },
  ]);
}
